import { useLocation, useNavigate } from "react-router-dom";
import { FiBookOpen, FiServer, FiCompass } from "react-icons/fi";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import MetricScreen from "../../components/Admin/Metric-Screen/MetricScreen";
import ApiDocumentation from "./ApiDocs/ApiDocumentation";
import UserGuide from "./UserGuide";

const KnowledgeCenterPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.endsWith("/api-endpoints")
    ? "api-endpoint-documentation"
    : location.pathname.endsWith("/user-guide")
      ? "user-guide"
      : "metric-dictionary";

  return (
    <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <div className="flex-grow">
        <Header />
        <main className="mx-4 mt-10 font-poppins sm:mx-10">
          <h1 className="text-2xl font-bold text-gray-700 mb-6">Knowledge Center</h1>
          <div className="flex flex-wrap items-center gap-4 bg-gray-50 rounded-lg px-4 py-3 mb-4">
            <button
              type="button"
              onClick={() => navigate("/knowledge-center/metric")}
              className={`flex items-center gap-2 px-4 py-2 rounded-md whitespace-nowrap transition ${
                activeTab === "metric-dictionary"
                  ? "bg-white text-red-500 border-b-2 border-red-300 shadow"
                  : "bg-gray-200 text-gray-600 hover:bg-gray-300"
              }`}
            >
              <FiBookOpen />
              Metric Dictionary
            </button>
            <button
              type="button"
              onClick={() => navigate("/knowledge-center/api-endpoints")}
              className={`flex items-center gap-2 px-4 py-2 rounded-md whitespace-nowrap transition ${
                activeTab === "api-endpoint-documentation"
                  ? "bg-white text-red-500 border-b-2 border-red-300 shadow"
                  : "bg-gray-200 text-gray-600 hover:bg-gray-300"
              }`}
            >
              <FiServer />
              API Documentation
            </button>
            <button
              type="button"
              onClick={() => navigate("/knowledge-center/user-guide")}
              className={`flex items-center gap-2 px-4 py-2 rounded-md whitespace-nowrap transition ${
                activeTab === "user-guide"
                  ? "bg-white text-red-500 border-b-2 border-red-300 shadow"
                  : "bg-gray-200 text-gray-600 hover:bg-gray-300"
              }`}
            >
              <FiCompass />
              User Guide
            </button>
          </div>
          <div className="bg-white shadow-lg rounded-lg min-h-[400px]">
            {activeTab === "metric-dictionary" && <MetricScreen />}
            {activeTab === "api-endpoint-documentation" && (
              <ApiDocumentation onOpenMetricDictionary={() => navigate("/knowledge-center/metric")} />
            )}
            {activeTab === "user-guide" && <UserGuide />}
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default KnowledgeCenterPage;
